import { useEffect } from "react";
import useTNStore from "@/stores/TNStore";
import { isValidTN } from "@/utils/general";

export default function useTNFromParams(params: { tn: string }) {
    const { tn, setTN } = useTNStore();

    useEffect(() => {
        // In case the current state isn't set and the URL param is, use it to set the state
        if (params.tn !== undefined && tn === "" && isValidTN(params.tn) && tn !== params.tn) {
            setTN(decodeURIComponent(params.tn));
        }
        useTNStore.persist.rehydrate();
    }, [tn, setTN, params.tn]);

    return { tn, setTN };
}
